var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 23.1748 24.3945",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.09261 22.8983V19.1687C8.09261 18.2167 8.87005 17.4449 9.82908 17.4449H13.3348C13.7953 17.4449 14.237 17.6265 14.5627 17.9498C14.8883 18.2731 15.0713 18.7115 15.0713 19.1687V22.8983C15.0683 23.2941 15.2247 23.6747 15.5056 23.9556C15.7865 24.2365 16.1687 24.3945 16.5675 24.3945H18.9592C20.0762 24.3974 21.1485 23.9589 21.9394 23.1758C22.7303 22.3927 23.1748 21.3293 23.1748 20.2204V9.59541C23.1748 8.69964 22.7748 7.84996 22.0827 7.27526L13.9464 0.824375C12.531 -0.306686 10.5032 -0.270167 9.13012 0.911109L1.17949 7.27526C0.454641 7.83302 0.021409 8.68522 0 9.59541V20.2096C0 22.5208 1.88738 24.3945 4.21558 24.3945H6.55272C7.38083 24.3945 8.05384 23.7312 8.05984 22.9092L8.09261 22.8983Z",
    fill: "var(--fill-0, #5D7285)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.20911c98997926f6f07e8befa35b911c.svg";
export { ForwardRef as ReactComponent };